import React from 'react'
import { MDBContainer, MDBModal, MDBModalBody } from 'mdbreact';
import { NumericFormat } from 'react-number-format';

const ModalAtributos = ({ estadoModal, controlModalProd, pedido, baseUrl }) => {
	const imagenDefault = 'https://app.bluemoonbeautysd.com/apibluemoon/productos/images/imagendefault.jpeg'

	const { nombre_producto, precio_producto,
		cantidad_producto, impuesto_producto,
		precio_rebajado, total_pedido, atributos, valorImpuesto } = pedido

	return (
		<React.Fragment>
			<MDBContainer>

				<MDBModal isOpen={estadoModal} toggle={controlModalProd} fullHeight position="left" >
					<div className="container overflow"></div>
					<div className="row sombra">
						<div className="col-8">
							<h4 className="tituloModal">Ver Producto:</h4>
						</div>
						<div className="col-4 cont_derecho_modal naranja">
							<button onClick={controlModalProd} className="btn boton_estandar btn-lg ">¡Ok!</button>
						</div>
					</div>
					<MDBModalBody >

						<React.Fragment>
							<div className="fotoProdModal">
								<h4>{nombre_producto}</h4>
							</div>
							<div className="PreciosProdModal sombra">
								<p>
									{precio_rebajado > 0 ?
										<div>
											<NumericFormat value={precio_producto} className="tachado" displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
											<span> - </span>
											<NumericFormat value={precio_rebajado} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
										</div>
										: <NumericFormat value={precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
									}
									<span><b> Valor Imp: </b><NumericFormat value={valorImpuesto} displayType={'text'} thousandSeparator={true} prefix={'$'} /><br /></span>
									<span><b> Total: <NumericFormat value={total_pedido} displayType={'text'} thousandSeparator={true} prefix={'$'} /></b> <br />Imp: {impuesto_producto} <br />Cantidad: {cantidad_producto}</span>
								</p>
							</div>
							<div>
								{atributos && atributos.map((item, i) => {
									if (pedido.combo === "true") {
										const imagenProducto = item.producto?.imagePrev?.[0]?.nombre_imagen
											? `${baseUrl}productos/${item.producto.imagePrev[0].nombre_imagen}`
											: imagenDefault

										return (<div className="cardAtriProd sombra text-left" key={i}>
											<div className='row'>
												<div className='col-4'><img
													className="w-100"
													src={imagenProducto}
													alt={item.producto.nombre_producto}
													loading="lazy"
													decoding="async"
													onError={(e) => {
														e.currentTarget.onerror = null
														e.currentTarget.src = imagenDefault
													}}
												/></div>
												<div className='col'>
													<p className='p-0 m-0'>{item.producto.nombre_producto}</p>
													<AtributosProducto item={item} />
												</div>
											</div>

										</div>)
									}
									return (
										<div className="cardAtriProd sombra" key={i}>
											<span>{item.categoria} {">"} {item.atributo?.opcion} </span>
											<span>({cantidad_producto})</span>
										</div>
									);
								})}
							</div>
						</React.Fragment>


					</MDBModalBody>
				</MDBModal>
			</MDBContainer>
		</React.Fragment>
	)
}



const AtributosProducto = ({ item }) => {
	if (!item.atributos && !item.opciones && item.producto) return (
		<>
			<span>(x{item.cantidad}) {item.producto.nombre_producto} </span>
		</>
	)

	if (item.opciones.padre == 'Colores') return (
		<>
			<span>(x{item.cantidad}) {item.opciones.padre}: </span>
			<button type="button" key={item.opciones.color} className={`btn-colores-opciones   btn`} style={{ background: item.opciones.color }} />
		</>
	)

	return (
		<>
			<span>(x{item.cantidad}) {item.opciones.padre}: </span>
			<button type="button" key={item.opciones.nombre} className={` btn btn-sm producto-atributos-btn`}>{item.opciones.nombre}</button>
		</>
	)
}

export default ModalAtributos
